import { FaWineBottle } from "react-icons/fa";
import { defineType } from "sanity";
import { multilingualStringPreview } from "../base/multilingualArrayString";

export default defineType({
  name: "themedCruise",
  title: "Themed Cruise",
  type: "document",
  icon: FaWineBottle,
  preview: {
    select: {
      name: "name",
      code: "code"
    },
    prepare(value) {
      const name = multilingualStringPreview(value.name);
      return {
        title: value.code ? `${name} (${value.code})` : name
      };
    }
  },
  fields: [
    {
      name: "code",
      title: "Code",
      type: "string",
      validation: (Rule) => Rule.required()
    },
    {
      name: "name",
      title: "Name",
      type: "multilingualArrayString",
      validation: (Rule) => Rule.required()
    },
    {
      name: "fycFilterDescription",
      title: "FYC filter description",
      type: "multilingualArrayText",
      options: { collapsible: true, collapsed: true }
    },
    {
      name: "cruiseCodes",
      title: "Cruise Codes",
      description: "list of cruise codes (one per row) without any comma",
      type: "text"
    }
  ]
});
